import { useState, useEffect, useCallback } from 'react'

import { EXTENSION_ID } from '../utils/exploitPayloads'

export const useExtensionDetection = () => {
  const [isInstalled, setIsInstalled] = useState<boolean | null>(null)
  const [isChecking, setIsChecking] = useState(true)

  const checkExtension = useCallback(async () => {
    setIsChecking(true)
    try {
      await fetch(`chrome-extension://${EXTENSION_ID}/libs/requests.js`)
      setIsInstalled(true)
    } catch {
      setIsInstalled(false)
    }
    setIsChecking(false)
  }, [])

  useEffect(() => {
    checkExtension()
  }, [checkExtension])

  return {
    isInstalled,
    isChecking,
    recheckExtension: checkExtension,
  }
}

export default useExtensionDetection
